document.addEventListener('DOMContentLoaded', function() {
    const cartFormSubmit = document.querySelector('.product__info-container product-form .product-form__submit[name="add"]');
    //cartFormSubmit.setAttribute('disabled', 'disabled');
    let variantSelector = document.querySelector('variant-radios script[type="application/json"]');

    let variantData = null;
  
    if(variantSelector != null)
      variantData = JSON.parse(variantSelector.textContent);
  
    let current;


  /*
    if (variantData[splide.index - 1]['available'] === true) {
        cartFormSubmit.removeAttribute('disabled');
        cartFormSubmit.querySelector('[name="add"] > span').textContent = window.variantStrings.addToCart;
    } else {
        cartFormSubmit.setAttribute('disabled', 'disabled');
        cartFormSubmit.querySelector('[name="add"] > span').textContent = window.variantStrings.soldOut;
    }
  */
});
